// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__3OCcO","Modal_content":"Modal_Modal_content__3NaAI","Modal_content_text_styled":"Modal_Modal_content_text_styled__1JM6A"};